<div [style.width.px]="size" [style.height.px]="size">
  @if (user != null && can_remove && userClicked.observers.length > 0) {
    <div class="click-element" style="cursor: pointer" (click)="onUserClick()">
      <mat-icon>close</mat-icon>
    </div>
  }
  <div [style.width.px]="size" [style.height.px]="size" class="assignee-container">
    <app-user-profile-picture
      [user]="user"
      [size]="size"
      [css_class]="'assignee-image'"
      [alt]="user?.full_name ?? ''"
      [border_color]="
        $safeNavigationMigration(company_product_user_member?.company_product_user_member_role?.slug)
          | companyProductUserMemberRoleToColorPipe
      "
    />
    <div
      class="role-icon-container"
      [style.top]="-size / 2 + 'px'"
      [style.background-color]="
        $safeNavigationMigration(company_product_user_member?.company_product_user_member_role?.slug)
          | companyProductUserMemberRoleToColorPipe
      "
      [style.width.px]="size / 2"
      [style.height.px]="size / 2"
    >
      <mat-icon [style.font-size]="size / 4 + 'px'" [style.width.px]="size / 2" [style.height.px]="size / 2">{{
        $safeNavigationMigration(company_product_user_member?.company_product_user_member_role?.slug)
          | companyProductUserMemberRoleToIconPipe
      }}</mat-icon>
    </div>
  </div>
</div>
